export const getPersistedFbclid = () => {
    if (!process.client) return '';

    // First check the current URL
    const currentFbclid = new URLSearchParams(window.location.search)
        .get('fbclid');

    if (currentFbclid) {
        sessionStorage.setItem('fbclid', currentFbclid);
        return currentFbclid;
    }

    // Otherwise, use the value saved earlier in the booking journey
    return sessionStorage.getItem('fbclid') || '';
};

export const buildFbcFromFbclid = () => {
    const fbclid = getPersistedFbclid();
    if (!fbclid) return '';
    return `fb.1.${Date.now()}.${fbclid}`;
};

export const hasMarketingConsent = () => {
    if (!process.client) return false;

    const cookie = document.cookie
        .split('; ')
        .find(row => row.startsWith('cookieyes-consent='));

    if (!cookie) return false;

    const value = decodeURIComponent(cookie.split('=').slice(1).join('='));
    const consent = Object.fromEntries(
        value.split(',').map(item => {
            const [key, ...rest] = item.split(':');
            return [key, rest.join(':')];
        })
    );

    return consent.action === 'yes'
        && consent.consent === 'yes'
        && consent.advertisement === 'yes';
};
